export default __webpack_public_path__ + "static/media/openvino-toolkit-alt.6e0cc922.svg";